import { debounce } from "lodash";
// import { action, observable } from "mobx";
// import { observer } from "mobx-react";
// import { AllSelection } from "prosemirror-state";
import * as React from "react";
// import { WithTranslation, withTranslation } from "react-i18next";
// import {
//   Prompt,
//   RouteComponentProps,
//   StaticContext,
//   withRouter,
//   Redirect,
// } from "react-router";
import Flex from "src/app/components/Flex";

import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import { Heading } from "../../../../shared/editor/lib/getHeadings";

// import { NavigationNode } from "../../../../shared/types";

import type { Editor as TEditor } from "../../../editor";
import Container from "./Container";
import Editor from "./Editor";
import Contents from "./Contents";


type Props = {
  onCreateLink?: (title: string) => Promise<string>;
  onSearchLink?: (term: string) => any;
};
const defaultValue = ":smile: Hi there, \n :::info \n I’ll show you how to use this exciting editor. \n  ::: \n :::warning \n Add-ons can be easily utilized by either typing \"/\" or clicking the \"+\" button at the beginning of a new line.  \n  ::: \n :::tip \n All elements, including tables, dividers, and text, are interactive and customizable. Feel free to explore and experiment with them. \n  ::: \n > Headings are displayed on the left side, and when you paste links from websites such as YouTube, Figma, and others, previews are generated for convenient reference.";

class DocumentScene extends React.Component<Props> {
  editor = React.createRef<TEditor>();

  state = {
    isUploading: false,
    title: 'zcx',
    headings: [],
    editorTextP: defaultValue
  }
  getEditorText: () => string = () => this.state.editorTextP;

  // getEditorText: () => string = () => this.props.document.text,


  // @observable
  // isSaving = false;

  // @observable
  // isPublishing = false;

  // @observable
  // isEditorDirty = false;

  // @observable
  // isEmpty = true;

  // @observable
  // lastRevision: number = this.props.document.revision;

  // @observable
  // title: string = 'zcx';

  // @observable
  // headings: Heading[] = [];

  // getEditorText: () => string = () => this.props.document.text;

  // state = {
  //   editorTextP: this.props.document.text,
  // }
  // componentDidMount() {
  //   this.updateIsDirty();
  // }

  componentDidUpdate(prevProps: Props) {
    // const { auth, document, t } = this.props;

    // if (prevProps.readOnly && !this.props.readOnly) {
    //   this.updateIsDirty();
    // }

    // if (this.props.readOnly || auth.team?.collaborativeEditing) {
    //   this.lastRevision = document.revision;
    // }

    // if (
    //   !this.props.readOnly &&
    //   !auth.team?.collaborativeEditing &&
    //   prevProps.document.revision !== this.lastRevision
    // ) {
    //   if (auth.user && document.updatedBy.id !== auth.user.id) {
    //     this.props.toasts.showToast(
    //       t(`Document updated by {{userName}}`, {
    //         userName: document.updatedBy.name,
    //       }),
    //       {
    //         timeout: 30 * 1000,
    //         type: "warning",
    //         action: {
    //           text: "Reload",
    //           onClick: () => {
    //             window.location.href = documentUrl(document);
    //           },
    //         },
    //       }
    //     );
    //   }
    // }
  }

  // componentWillUnmount() {
  //   if (
  //     this.isEmpty &&
  //     this.props.document.createdBy.id === this.props.auth.user?.id &&
  //     this.props.document.isDraft &&
  //     this.props.document.isActive &&
  //     this.props.document.hasEmptyTitle &&
  //     this.props.document.isPersistedOnce
  //   ) {
  //     this.props.document.delete();
  //   }
  // }

  // replaceDocument = (template: Document | Revision) => {
  //   const editorRef = this.editor.current;

  //   if (!editorRef) {
  //     return;
  //   }

  //   const { view, parser } = editorRef;
  //   view.dispatch(
  //     view.state.tr
  //       .setSelection(new AllSelection(view.state.doc))
  //       .replaceSelectionWith(parser.parse(template.text))
  //   );

  //   this.isEditorDirty = true;

  //   if (template instanceof Document) {
  //     this.props.document.templateId = template.id;
  //   }

  //   if (!this.title) {
  //     const title = replaceTitleVariables(
  //       template.title,
  //       this.props.auth.user || undefined
  //     );
  //     this.title = title;
  //     this.props.document.title = title;
  //   }

  //   this.props.document.text = template.text;
  //   this.updateIsDirty();
  //   this.onSave({
  //     autosave: true,
  //     publish: false,
  //     done: false,
  //   });
  // };

  // onSynced = async () => {
  //   const { toasts, history, location, t } = this.props;
  //   const restore = location.state?.restore;
  //   const revisionId = location.state?.revisionId;
  //   const editorRef = this.editor.current;

  //   if (!editorRef || !restore) {
  //     return;
  //   }

  //   const response = await client.post("/revisions.info", {
  //     id: revisionId,
  //   });

  //   if (response) {
  //     this.replaceDocument(response.data);
  //     toasts.showToast(t("Document restored"));
  //     history.replace(this.props.document.url, history.location.state);
  //   }
  // };

  // onMove = (ev: React.MouseEvent | KeyboardEvent) => {
  //   ev.preventDefault();
  //   const { document, dialogs, t, abilities } = this.props;
  //   if (abilities.move) {
  //     dialogs.openModal({
  //       title: t("Move document"),
  //       isCentered: true,
  //       content: <DocumentMove document={document} />,
  //     });
  //   }
  // };

  // goToEdit = (ev: KeyboardEvent) => {
  //   if (!this.props.readOnly) {
  //     return;
  //   }
  //   ev.preventDefault();
  //   const { document, abilities } = this.props;

  //   if (abilities.update) {
  //     this.props.history.push(editDocumentUrl(document));
  //   }
  // };

  // goToHistory = (ev: KeyboardEvent) => {
  //   if (!this.props.readOnly) {
  //     return;
  //   }
  //   if (ev.ctrlKey) {
  //     return;
  //   }
  //   ev.preventDefault();
  //   const { document, location } = this.props;

  //   if (location.pathname.endsWith("history")) {
  //     this.props.history.push(document.url);
  //   } else {
  //     this.props.history.push(documentHistoryUrl(document));
  //   }
  // };

  // onPublish = (ev: React.MouseEvent | KeyboardEvent) => {
  //   ev.preventDefault();
  //   const { document, dialogs, t } = this.props;
  //   if (document.publishedAt) {
  //     return;
  //   }

  //   if (document?.collectionId) {
  //     this.onSave({
  //       publish: true,
  //       done: true,
  //     });
  //   } else {
  //     dialogs.openModal({
  //       title: t("Publish document"),
  //       isCentered: true,
  //       content: <DocumentPublish document={document} />,
  //     });
  //   }
  // };

  // onToggleTableOfContents = (ev: KeyboardEvent) => {
  //   if (!this.props.readOnly) {
  //     return;
  //   }
  //   ev.preventDefault();
  //   const { ui } = this.props;

  //   if (ui.tocVisible) {
  //     ui.hideTableOfContents();
  //   } else {
  //     ui.showTableOfContents();
  //   }
  // };

  // onSave = async (
  //   options: {
  //     done?: boolean;
  //     publish?: boolean;
  //     autosave?: boolean;
  //   } = {}
  // ) => {
  //   const { document } = this.props;
  //   // prevent saves when we are already saving
  //   if (document.isSaving) {
  //     return;
  //   }

  //   // get the latest version of the editor text value
  //   const text = this.getEditorText && this.getEditorText();

  //   // prevent save before anything has been written (single hash is empty doc)
  //   if (text.trim() === "" && document.title.trim() === "") {
  //     return;
  //   }

  //   document.text = text;

  //   prevent autosave if nothing has changed
  //   if (options.autosave && !this.isEditorDirty && !document.isDirty()) {
  //     return;
  //   }

  //   this.isSaving = true;
  //   this.isPublishing = !!options.publish;

  //   try {
  //     const savedDocument = await document.save({
  //       ...options,
  //       lastRevision: this.lastRevision,
  //     });

  //     this.isEditorDirty = false;
  //     this.lastRevision = savedDocument.revision;

  //     if (options.done) {
  //       this.props.history.push(savedDocument.url);
  //       this.props.ui.setActiveDocument(savedDocument);
  //     } else if (document.isNew) {
  //       this.props.history.push(editDocumentUrl(savedDocument));
  //       this.props.ui.setActiveDocument(savedDocument);
  //     }
  //   } catch (err) {
  //     this.props.toasts.showToast(err.message, {
  //       type: "error",
  //     });
  //   } finally {
  //     this.isSaving = false;
  //     this.isPublishing = false;
  //   }
  // };

  // autosave = debounce(() => {
  //   this.onSave({
  //     done: false,
  //     autosave: true,
  //   });
  // }, AUTOSAVE_DELAY);

  // updateIsDirty = () => {
  //   const { document } = this.props;
  //   const editorText = this.getEditorText().trim();
  //   this.isEditorDirty = editorText !== document.text.trim();

  //   // a single hash is a doc with just an empty title
  //   this.isEmpty =
  //     (!editorText || editorText === "#" || editorText === "\\") && !this.title;
  // };

  // updateIsDirtyDebounced = debounce(this.updateIsDirty, 500);

  onFileUploadStart = () => {
    this.setState({ isUploading: true });

  };

  onFileUploadStop = () => {
    this.setState({ isUploading: false });
  };

  onChange = (getEditorText: () => string) => {
    // const { document, auth } = this.props;
    this.getEditorText = getEditorText;
    
    // this.setState({ editorTextP: text });
    // Keep derived task list in sync
    // If the multiplayer editor is enabled we're done here as changes are saved
    // through the persistence protocol. The rest of this method is legacy.
    // if (auth.team?.collaborativeEditing) {
    //   return;
    // }

    // document change while read only is presumed to be a checkbox edit,
    // in that case we don't delay in saving for a better user experience.
    // if (this.props.readOnly) {
    //   this.updateIsDirty();
    //   this.onSave({
    //     done: false,
    //     autosave: true,
    //   });
    // } else {
    //   this.updateIsDirtyDebounced();
    //   this.autosave();
    // }
  };

  onHeadingsChange = (headings: Heading[]) => {
    this.setState({ headings });
    // this.headings = headings;
  };

  onChangeTitle = (value: string) => {
    // this.title = value;
    this.setState({ title: value });
    // this.props.document.title = value;
  };

  // goBack = () => {
  //   if (!this.props.readOnly) {
  //     this.props.history.push(this.props.document.url);
  //   }
  // };

  render() {
    // const {
    //   document,
    //   revision,
    //   readOnly,
    //   abilities,
    //   auth,
    //   ui,
    //   shareId,
    //   t,
    // } = this.props;
    // const team = auth.team;
    // const isShare = !!shareId;
    // const embedsDisabled =
    //   (team && team.documentEmbeds === false) || document.embedsDisabled;

    // const hasHeadings = this.headings.length > 0;
    // const showContents =
    //   ui.tocVisible &&
    //   ((readOnly && hasHeadings) || team?.collaborativeEditing);
    // const collaborativeEditing =
    //   team?.collaborativeEditing &&
    //   !document.isArchived &&
    //   !document.isDeleted &&
    //   !revision &&
    //   !isShare;

    // const canonicalUrl = shareId
    //   ? this.props.match.url
    //   : updateDocumentUrl(this.props.match.url, document);

    return (
      <MaxWidth
        archived={false}
        showContents={true}
        isEditing={true}
        isFullWidth={false}
        column
        auto
      >
        <Flex auto={true} reverse>
          <Editor
            // key={embedsDisabled ? "disabled" : "enabled"}
            key={"enabled"}
            value={this.state.editorTextP}
            ref={this.editor}
            // template={document.isTemplate}
            // value={this.state.editorTextP}
            // value={readOnly ? document.text : undefined}
            defaultValue={this.state.editorTextP}
            embedsDisabled={false}
            // onSynced={this.onSynced}
            onFileUploadStart={this.onFileUploadStart}
            onFileUploadStop={this.onFileUploadStop}
            onCreateLink={this.props.onCreateLink}
            onChangeTitle={this.onChangeTitle}
            onChange={this.onChange}
            onHeadingsChange={this.onHeadingsChange}
            // onSave={this.onSave}
            // onCancel={this.goBack}
            readOnly={false}
            readOnlyWriteCheckboxes={false}
          >
          </Editor>
          <Contents
            headings={this.state.headings}
            isFullWidth={true}
          />
        </Flex>
      </MaxWidth>
    );
  }
}

const Background = styled(Container)`
  background: ${(props) => props.theme.background};
  transition: ${(props) => props.theme.backgroundTransition};
`;

const ReferencesWrapper = styled.div<{ isOnlyTitle?: boolean }>`
  margin-top: ${(props) => (props.isOnlyTitle ? -45 : 16)}px;

  @media print {
    display: none;
  }
`;

type MaxWidthProps = {
  isEditing?: boolean;
  isFullWidth?: boolean;
  archived?: boolean;
  showContents?: boolean;
};

const MaxWidth = styled(Flex) <MaxWidthProps>`
  // Adds space to the gutter to make room for heading annotations
  padding: 0 32px;
  transition: padding 100ms;
  max-width: 100vw;
  width: 100%;

  padding-bottom: 16px;

  ${breakpoint("tablet")`
    margin: 4px auto 12px;
    max-width: ${(props: MaxWidthProps) =>
      props.isFullWidth
        ? "100vw"
        : `calc(64px + 46em + ${props.showContents ? "256px" : "0px"});`}
  `};

  ${breakpoint("desktopLarge")`
    max-width: ${(props: MaxWidthProps) =>
      props.isFullWidth ? "100vw" : `calc(64px + 52em);`}
  `};
`;

export default DocumentScene;
